// --------------------------------------------------------------------------
// #18 - Video
// --------------------------------------------------------------------------
// Author:      Sarah Blount
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

/* global dataLayer, YT */

'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var context = options.context;

    function init() {
        var jqPlayButton = context.find('.play-button');
        var playerType = context.find('.video-player').data('video-type');
        var players = [];

        function returnToStart() {
            jqPlayButton.show();
            context.find('iframe:visible').css('left', '100%');
            dataLayer.push({ 'event': 'endVideo' });
        }

        function switchToPlayer(button) {
            var jqVideoPlayer = button.parent().find('iframe');
            jqVideoPlayer.css('left', '0');
            jqVideoPlayer.trigger('click');
            button.hide();
            dataLayer.push({ 'event': 'playVideo' });
        }

        function onPlayerStateChange(e) {
            if (e.data === YT.PlayerState.ENDED) {
                returnToStart();
            }
        }

        function playVideo(e) {
            e.playVideo();
        }

        function onVimeoPlayerReady(videoId) {
            var iframe = $('#' + videoId)[0];
            var url = $(iframe).attr('src').split('?')[0];

            // Helper function for sending a message to the vimeo player
            function post(action, value) {
                var data = {
                    method: action
                };

                if (value) {
                    data.value = value;
                }

                iframe.contentWindow.postMessage(data, url);
            }

            // Start vimeo video on play button
            jqPlayButton.on('click', function (e) {
                e.preventDefault();
                switchToPlayer($(this));
                post('play');
            });

            // Handle messages received from the vimeo player
            function onMessageReceived(e) {
                var data = e.data;
                switch (data.event) {
                    case 'ready':
                        post('addEventListener', 'finish');
                        break;

                    case 'finish':
                        returnToStart();
                        break;
                }
            }

            // Listen for messages from the vimeo player
            if (window.addEventListener) {
                window.addEventListener('message', onMessageReceived, false);
            } else {
                window.attachEvent('onmessage', onMessageReceived, false);
            }
        }
        function createNewVimeoPlayer() {
            // Add vimeo iframe to page based on id
            context.find('.video-player').each(function (index, video) {
                var jqVideoWrapper = $(this);
                var videoId = $(video).data('video-id');

                $.getJSON('https://www.vimeo.com/api/oembed.json?url=' + encodeURIComponent('https://vimeo.com/' + videoId) + '&width=300&callback=?', function (data) {
                    jqVideoWrapper.html(data.html);
                    context.find('iframe').attr('id', videoId);
                    onVimeoPlayerReady(videoId);
                });
            });
        }

        function onYTPlayerReady(event) {
            // Start youtube video on play button
            $('#' + event.target.a.id).parent().find('.play-button').on('click', function (e) {
                var target = event ? event.target : window.event.srcElement;
                e.preventDefault();
                switchToPlayer($(this));
                playVideo(target);
            });
        }

        function createNewYTPlayer(options) {
            // Add youtube player to page based on id
            players[options.id] = new YT.Player('video-' + options.id, {
                height: '390',
                width: '640',
                videoId: options.id,
                playerVars: {
                    wmode: 'transparent'
                },
                events: {
                    'onReady': onYTPlayerReady,
                    'onStateChange': onPlayerStateChange
                }
            });
            return players[options.id];
        }

        // Check the type of video
        if (playerType === 'youtube') {
            // Load the Youtube IFrame Player API code asynchronously.
            var tag = document.createElement('script');

            tag.src = 'https://www.youtube.com/iframe_api';

            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

            window.onYouTubePlayerAPIReady = function () {

                context.find('.video-player').each(function (index, video) {
                    createNewYTPlayer({
                        id: $(video).data('video-id')
                    });
                });
            };
        }
        if (playerType === 'vimeo') {
            createNewVimeoPlayer();
        }

        // Show transcript on click
        var $showTranscriptBtn = context.find('.video-block__transcript .show-button');
        $showTranscriptBtn.on('click', function (e) {
            e.preventDefault();
            var videoDescription = $(this).next();
            var buttonDescription = $(this);
            if (videoDescription.hasClass('focus')) {
                videoDescription.removeClass('focus');
                buttonDescription.text(buttonDescription.attr('data-text-show'));
            } else {
                videoDescription.addClass('focus');
                buttonDescription.text(buttonDescription.attr('data-text-hide'));
            }
        });

        //add click event just for ie
        if ($('html.lt-ie9')) {
            jqPlayButton.on('click', function (e) {
                e.preventDefault();
                switchToPlayer($(this));
            });
        }
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/video-play.js
// module id = 196
// module chunks = 0